import { HarvestTypes } from "@gtpl/shared-models/common-models";
import { CompanyCategoryEnum } from "../rm-count-pricelist";

export class RmBudgetInfoReq {
    count:number
    reweighmentDate?:Date

    constructor(
        count:number,
        reweighmentDate?:Date
    ){
        this.reweighmentDate = reweighmentDate
        this.count = count
    }
}
